/* eslint-disable react/jsx-pascal-case */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import "./App.css";
import { useLocation, redirect } from "react-router-dom";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import { useDispatch, useSelector } from "react-redux";
import { getUserDetails, showTopPlaces } from "./utils/action/Action";
import { ToastContainer } from "react-toastify";
import Loader from "./components/Loader/Loader";
import { getUserPoints } from "./services/points.service";
import { refresh } from "./services/auth.service";
import Clarity from "@microsoft/clarity"
import axios from "axios";
import {
  resetUserDetail,
  addPointNotification,
  buyPointNotification,
} from "./utils/action/Action";
import { persistedStore } from "./utils/store/Store";
import Router from "./Router";

function App() {
  const location = useLocation();
  const [pathName, setPathName] = useState(null);
  const [isUserLoggedIn, setUserLoggedIn] = useState(
    localStorage.getItem("token"),
  );
  const [userPoints, setUserPoints] = useState();
  let isRefreshing = false;

  const show = useSelector((state) => state.loadingActionReducer.loading);
  const hide = useSelector((state) => state.loadingActionReducer.loading);
  const userName = useSelector(
    (state) => state.userDetailReducer.userData.userName,
  );
  let scriptSrc;
  if (process.env.REACT_APP_ENV === "staging") {
    scriptSrc = "https://sandbox.usaepay.com/js/v1/pay.js";
  } else if (process.env.REACT_APP_ENV === "production") {
    scriptSrc = "https://usaepay.com/js/v1/pay.js"; // Replace with your live script URL
  }

  const dispatch = useDispatch();

  Clarity.init("vn001likay");

  // useEffect(() => {
  // 	setInterval(loggedout(), 50000)
  // }, [])

  useEffect(() => {
    const savedToken = localStorage.getItem("token");
    if (savedToken && !userName) {
      console.log("wenqjkfewq");
      const fetchData = async () => {
        await dispatch(getUserDetails());
      };
      fetchData();
    }
  }, [dispatch, userName]);

  const loggedout = () => {
    console.log("loggin out auto.....");
    if (isUserLoggedIn) {
      userAuthentication();
      // clear local storage except pathName
      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
      // set last pathName
      if (pathName === "/category-list") {
        localStorage.setItem("Category", location?.state?.categoryName);
      }
      localStorage.setItem("pathName", pathName);
      persistedStore.purge();
      setUserPoints();
      dispatch(resetUserDetail());
      let obj = {
        notification: false,
      };
      dispatch(addPointNotification(obj));
      let object = {
        notification: false,
      };
      dispatch(buyPointNotification(object));
      redirect("/sign-in");
    }
  };

  useEffect(() => {
    isUserLoggedIn &&
      axios.interceptors.response.use(
        (response) => response,
        async (error) => {
          const config = error?.config;
          if (error?.response?.status === 401) {
            if (!isRefreshing) {
              isRefreshing = true;

              let refreshObj = {
                token: localStorage?.getItem("refresh_token"),
              };
              try {
                const res = await refresh(refreshObj);

                if (res?.data?.data?.access_token) {
                  config.headers = {
                    ...config.headers,
                    Authorization: "Bearer " + res?.data?.data?.access_token,
                  };
                  localStorage?.setItem(
                    "refresh_token",
                    res?.data?.data?.refresh_token,
                  );
                  localStorage?.setItem("token", res?.data?.data?.access_token);
                  isRefreshing = false;
                } else {
                  loggedout();
                  isRefreshing = false;
                }
              } catch (error) {
                loggedout();
                isRefreshing = false;
                return Promise.reject(error);
              }
            }

            return axios(config);
          }
          return Promise.reject(error);
        },
      );
  }, []);

  useEffect(() => {
    setPathName(location?.pathname);
  }, [location]);

  if (show === true) {
    document.body.classList.add("backHidden");
  } else if (hide === false) {
    document.body.classList.remove("backHidden");
  }

  useEffect(() => {
    if (
      location?.pathname === "/" ||
      location?.pathname === "/favourites" ||
      location?.pathname === "/plan-your-trip" ||
      location?.pathname === "/search-everywhere" ||
      location?.pathname === "/category-list"
    ) {
      dispatch(showTopPlaces());
    }
  }, [location?.pathname]);

  const userAuthentication = () => {
    setUserLoggedIn(!isUserLoggedIn);
  };

  useEffect(() => {
    if (isUserLoggedIn) {
      getPoints();
    }
  }, [userName]);

  const getPoints = async () => {

    if (!userName || userName === "undefined") {
      await dispatch(getUserDetails());
    }

    try {
      const response = await getUserPoints({
        userName: userName,
      });
      if (response && response?.status === 200) {
        setUserPoints(response?.data?.data?.userPoints);
      }
    } catch (err) {
      setUserPoints(userPoints);
    }
  };

  return (
    <>
      {show && <Loader />}
      <ToastContainer />
      {pathName !== "/" && (
        <Header
          pathName={pathName}
          userPoints={userPoints}
          setUserPoints={setUserPoints}
          isUserLoggedIn={isUserLoggedIn}
          userAuthentication={userAuthentication}
        />
      )}
      <div style={{ minHeight: "calc(100vh - 250px)", background: "#FFFCF8" }}>
        <Router
          isUserLoggedIn={isUserLoggedIn}
          getPoints={getPoints}
          userAuthentication={userAuthentication}
          pathName={pathName}
          userPoints={userPoints}
          setUserPoints={setUserPoints}
        />
      </div>
      {pathName === "/sign-in" ||
        pathName === "/sign-up" ||
        pathName === "/forgot-password" ||
        pathName === "/resetpassword" ? null : (
        <Footer />
      )}
      <script src={scriptSrc}></script>
    </>
  );
}

export default App;
